/*
 * @Descripttion:
 * @version:
 * @Author: susj
 * @Date: 2020-09-11 09:48:06
 * @LastEditors: susj
 * @LastEditTime: 2020-09-11 10:33:11
 */
export default {
  path: '/scheme/edit/:id',
  name: 'Scheme.Edit',
  component: () => import(/* webpackChunkName: "form" */ '@/views/modules/scheme/edit/Edit.vue'),
  hiddenInMenu: true,
  meta: {
    title: '方案秀编辑',
    icon: 'database',
  },
};
